module.exports = __webpack_public_path__ + "static/img/P5.800016e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leishenx/P5.png
// module id = TnPO
// module chunks = 0